import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<{
    properties: {
        isSentinelUser?: string;
        isThinkificUser?: string;
    };
}>;

export const xDispatchUpdateUserSetup: HandlerType = props => {
    props.dispatch({
        ...props.parameter,
        type: "xUserSetup/updateUserSetup",
    } as any);
};

export const chain = [xDispatchUpdateUserSetup];

const xUpdateUserSetup = createHandlerChainRunner(chain, "xUpdateUserSetup");
export default xUpdateUserSetup;
